import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';

interface Props {
  path?: string;
  className?: string;
  customStyle?: any;
  click?: () => void;
}

const RouterLink: React.FC<Props> = ({ path, className, customStyle, click, children }) => {
  const history = useHistory();

  const handleClick = async (event: React.MouseEvent) => {
    event.preventDefault();

    if (click) {
      await click();
    }

    if (!path) return;
    history.push(path);
  };

  return (
    <a onClick={e => handleClick(e)} href="/" className={className} style={customStyle}>
      {children}
    </a>
  );
};

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0,0);
  }, [pathname]);

  return null;
}

export default RouterLink;
